<template>
  <b-col
    v-if="app.plans && app.plans.length"
  >
    <div
      id="plans"
      class="text-center mt-4"
    >
      <b-card-body class="card-body">
        <h2 class="text-primary">
          {{ $t('modules.apps._plans.title') }}
        </h2>
        <b-card-text>
          <span>{{ $t('modules.apps._plans.subtitle') }}</span>
        </b-card-text>
      </b-card-body>
    </div>
    <b-row class="pricing-card">
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto"
      >
        <b-row>
          <b-col
            v-for="plan in app.plans"
            :key="`plan-${plan.code}`"
          >
            <b-card
              align="center"
            >
              <h3>{{ plan.name }}</h3>
              <!--                <b-card-text>{{ pricing.basicPlan.subtitle }}</b-card-text>-->

              <!-- annual plan -->
              <div class="annual-plan">
                <div class="plan-price mt-2">
                  <span class="pricing-basic-value font-weight-bolder text-primary">{{ parseFloat(plan.final_price / 100).toFixed(0) }} {{ plan.currency_symbol }}</span>
                  <sub class="pricing-duration text-body font-medium-1 font-weight-bold"> / {{ plan.period_description }}</sub>
                </div>
              </div>
              <!--/ annual plan -->

              <!-- plan benefit -->
              <b-list-group class="list-group-circle text-left">
                <b-list-group-item
                  v-for="(feature,index) in app.features"
                  :key="index"
                >
                  {{ feature }}
                </b-list-group-item>
              </b-list-group>
              <!--/ plan benefit -->

              <!-- buttons -->
              <b-button
                v-if="app.can_try && plan.trial_days"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                block
                class="mt-2"
                variant="outline-success"
                @click="onTryAppClick(plan.code)"
              >
                {{ $t('modules.apps._plans.try_app') }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                block
                class="mt-2"
                variant="outline-success"
                @click="onAddToCartClick(plan.code)"
              >
                {{ $t('modules.subscriptions.actions.select') }}
              </b-button>

              <p
                v-if="plan.trial_days"
                class="pt-2 m-0"
              >
                {{ $t('modules.apps._plans.trial_days', {'days': plan.trial_days}) }}
              </p>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BListGroup,
  BListGroupItem,
  BButton,
  BCardBody,
  BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { usePurchaseCart } from '@/views/models/purchases/usePurchaseCart'
import { ref } from 'vue'
import axios from '@/libs/axios'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'
import { toast, catchException } from '@core/utils/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default {
  name: 'AppPlans',
  components: {
    BRow,
    BCol,
    BCard,
    BListGroup,
    BListGroupItem,
    BButton,
    BCardBody,
    BCardText,
  },
  directives: {
    Ripple,
  },
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { buyNow } = usePurchaseCart()
    const { t } = useI18nUtils()

    const onAddToCartClick = purchasableCode => {
      buyNow(purchasableCode).finally(() => {
        //
      })
    }

    const isLoading = ref(false)
    const onTryAppClick = planCode => {
      isLoading.value = true

      axios
        .post(`${jwtDefaultConfig.DASHBOARD_ENDPOINT}/apps/${props.app.id}/try`, {
          plan_code: planCode,
        })
        .then(response => {
          toast(
            'success',
            t('message.operation_success'),
            response?.data?.message || null,
            'CheckCircleIcon',
          )
          // Refresh the page
          window.location.reload()
        })
        .catch(e => {
          if (e?.response?.status === 422) {
            toast(
              'warning',
              e.response.data.message,
              null,
              'AlertTriangleIcon',
            )
            return
          }
          catchException(e)
          toast(
            'danger',
            t('message.operation_failed'),
            e?.response?.data?.message || null,
            'AlertTriangleIcon',
          )
        })
        .finally(() => {
          isLoading.value = false
        })
    }
    return {
      onAddToCartClick,
      onTryAppClick,
    }
  },
}
</script>

<style lang="scss" scoped>
.pricing-card {
  // Add any specific pricing card styles here if needed
}
</style>
